import React from 'react'
import ReactDOM from 'react-dom'
//import { Link } from 'react-router-dom'
import { logout, getConstructExFile, apiReferenceAuthorize } from '../../services/self'
import List from 'react-list-select'
import { Button, Form, Message, Modal } from 'semantic-ui-react'


export default class Reference extends React.Component{




  state = {
    name: '',
    allowed: ["nsellers", "fluxdev", "mickey", "donald"],
    nameIn: '',
    valueIn: ''
  }

  logout() {
    logout()
    this.setState({ loggedOut: true })
  }


  _getConstuctExFile = () => {
    var file;
    file = getConstructExFile();
    return file;
  }

  _addConstructExVis = () => {
    //let allowed = ["nsellers", "fluxdev", "mickey", "donald"];
    let items;
    var length = this.state.allowed.length;
    console.log(`length is ${length}`);
    var i = 0;
    for ( i=0; i < length; i++)
    {

      console.log(this.state.allowed[i]);

      //items.push(this.allowed[i]);
    }


    let list = (
      <List
        items={this.state.allowed}
        selected={[0]}
        multiple={true}
        onChange={(selected: number) => {console.log(selected);}}
        />
    )

    return list;
  }

  add = () => {
    this.setState({allowed: this.state.allowed.concat([this.state.name])})
  }

  _apiReferenceAuthorize = () => {
    apiReferenceAuthorize(this.state.nameIn, this.state.valueIn);
  }
//ConstructExAPI
render() {
  return(
<div>
  <div id="container">{this._addConstructExVis()}</div>
<div id="form">

<Form onSubmit={this.add} error={!!this.state.errorMessage} >
  <Form.Input label='Username' placeholder='Username' onChange={ (e) => this.setState({ name: e.target.value }) }/>

  <Message error content={this.state.errorMessage} />

  <Button primary type='submit'  style={{background: '#003C4D'}}>Add User</Button>
</Form>

</div>

<br />
<br />
<div>

<Form onSubmit={this._apiReferenceAuthorize} error={!!this.state.errorMessage} >
  <Form.Input label='API Reference Name' placeholder='constructex, enterprise, hybrid' onChange={ (e) => this.setState({ nameIn: e.target.value }) }/>
  <Form.Input label='True or False' placeholder='true or false' onChange={ (e) => this.setState({ valueIn: e.target.value }) }/>


  <Message error content={this.state.errorMessage} />

  <Button primary type='submit'  style={{background: '#003C4D'}}>Authorize?</Button>
</Form>

</div>

</div> )
}
}



/** WEBPACK FOOTER **
 ** ./src/pages/Admin/index.js
 **/